"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { Controller } from "@hotwired/stimulus";
export default class horizontal_menu_controller_default extends Controller {
  connect() {
    this._onResize = this._handleResize.bind(this);
    window.addEventListener("resize", this._onResize);
  }
  disconnect() {
    window.removeEventListener("resize", this._onResize);
  }
  toggle() {
    const isOpen = this.toggleTarget.getAttribute("aria-expanded") === "true";
    this._setOpen(!isOpen);
  }
  close() {
    this._setOpen(false);
  }
  // private
  _setOpen(open) {
    this.toggleTarget.setAttribute("aria-expanded", open);
    this.menuTarget.classList.toggle("hidden", !open);
    this.menuTarget.classList.toggle("show", open);
  }
  _handleResize() {
    if (window.innerWidth >= 1024) {
      this.menuTarget.classList.remove("hidden", "show");
      this.toggleTarget.setAttribute("aria-expanded", "false");
    }
  }
}
__publicField(horizontal_menu_controller_default, "targets", ["toggle", "menu"]);
